import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { CheckCircle2, Loader2, Send } from "lucide-react";
import { toast } from "sonner";

export default function EnquiryForm({ listingId, businessName }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post(`/listings/${listingId}/enquiries`, { ...form, phone: form.phone || null });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setSending(false); }
  };

  if (sent) {
    return (
      <div className="p-6 border border-green-200 bg-green-50 rounded-lg" data-testid="enquiry-success">
        <CheckCircle2 className="w-6 h-6 text-green-700 mb-2" />
        <p className="font-display text-lg font-bold">Enquiry sent</p>
        <p className="text-sm text-zinc-700 mt-1">{businessName} will reply to you by email.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="p-6 border border-zinc-200 bg-white rounded-lg space-y-4" data-testid="enquiry-form">
      <p className="font-display text-xl font-bold">Send an enquiry</p>
      <div>
        <Label htmlFor="enq-name">Your name</Label>
        <Input id="enq-name" required value={form.name} onChange={set("name")} className="mt-1" data-testid="enquiry-name" />
      </div>
      <div>
        <Label htmlFor="enq-email">Email</Label>
        <Input id="enq-email" type="email" required value={form.email} onChange={set("email")} className="mt-1" data-testid="enquiry-email" />
      </div>
      <div>
        <Label htmlFor="enq-phone">Phone (optional)</Label>
        <Input id="enq-phone" value={form.phone} onChange={set("phone")} className="mt-1" data-testid="enquiry-phone" />
      </div>
      <div>
        <Label htmlFor="enq-msg">Message</Label>
        <Textarea id="enq-msg" rows={4} required value={form.message} onChange={set("message")} className="mt-1"
          placeholder="Describe the job, location and when you need it." data-testid="enquiry-message" />
      </div>
      <Button type="submit" disabled={sending} className="w-full bg-black text-white hover:bg-zinc-800" data-testid="enquiry-submit">
        {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Send className="w-4 h-4 mr-2" /> Send enquiry</>}
      </Button>
    </form>
  );
}
